export const mainSiteUrl = "https://kaspreadsheet.com";

export const siteName = "BasetaoSheet";

export const siteUrl: string = (
  import.meta.env.VITE_SITE_URL || "https://basetaosheet.baby"
).replace(/\/$/, "");

export interface NavItem {
  label: string;
  href: string;
  icon: string;
  scrollTo?: string;
}

export const navItems: NavItem[] = [
  { label: "Home", href: "/", icon: "ri-home-4-line" },
  { label: "Shopping Guide", href: "/basetao-buyer-guide", icon: "ri-shopping-bag-3-line" },
  { label: "Spreadsheet Guide", href: "/basetao-spreadsheet-guide", icon: "ri-file-list-3-line" },
  { label: "Categories", href: "/", icon: "ri-grid-line", scrollTo: "categories" },
  { label: "QC Guide", href: "/basetao-qc-guide", icon: "ri-focus-3-line" },
  { label: "Shipping", href: "/basetao-shipping-cost", icon: "ri-ship-line" },
  { label: "Safety", href: "/basetao-safety", icon: "ri-shield-check-line" },
  { label: "FAQ", href: "/", icon: "ri-question-line", scrollTo: "faq" },
];

export const languages = [
  { code: "en", label: "English", short: "EN" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "de", label: "Deutsch", short: "DE" },
  { code: "es", label: "Español", short: "ES" },
  { code: "pt", label: "Português", short: "PT" },
];